import React, { Component, Fragment, PureComponent } from 'react';
import { connect } from 'react-redux';
import { Link, withRouter } from 'react-router-dom';

import { image_url, host_name } from '../../../config/Api';
import { getNewsDetails } from '../../actions/Publication';
import Timestamp from 'react-timestamp';
import Htmlcontent from '../Htmlcontent';
import TagNews from '../tag/TagNews'

import {
  FacebookShareButton, FacebookIcon,
  LinkedinShareButton, LinkedinIcon,
  TwitterShareButton, TwitterIcon
} from "react-share";


class Newsdetails extends PureComponent {

  constructor(props) {
    super(props);
    this.state = {
      content: {},
      slug: '',
      newsid: '',
      catid: '',
      content_loading: true,
      prevSlug: '',
      currentSlug: '',
    }


  }

  componentDidMount = () => {
    const slug = this.props.slug;
    const newsid = this.props.newsid;
    const catid = this.props.catid;
    console.log('this.props=', this.props)
    const req = this.props.getNewsDetails(catid, newsid).then((data) => {
      this.setState({
        catid: catid,
        slug: slug,
        newsid: newsid,
      })
    });

    window.scroll({ top: 0, left: 0, behavior: 'smooth' });
    console.log("details component did mount")
  }

  componentDidUpdate = (prevProps) => {
    const { slug } = this.props.match.params;
    const { slug: prevSlug } = prevProps.match.params;

    if (prevSlug != slug) {
      this.setState({
        prevSlug:prevSlug,
        currentSlug:slug,
      })
    }
    // console.log('this.props.match prevSlug', prevSlug);
    // console.log('this.props.match current', slug);

  }

  static getDerivedStateFromProps(props, state) {

    if (props.details.content !== state.content) {
      return {
        content: props.details.content,
        content_loading: props.details.content_loading,
      }
    }
    return null;

  }

  handleLoadContent = (catid, id) => {
    window.scroll({ top: 0, left: 0, behavior: 'smooth' });
    const req = this.props.getNewsDetails(catid, id).then((data) => {
      this.setState({
        content: data,
        slug: id
      })
    });
  }

  

  render() {

    const { content, content_loading, slug,prevSlug,currentSlug } = this.state;
    // const details = this.props.details;
    // console.log("this.props = ", this.props);

    console.log("this.state=", this.state);
    const shareulr = host_name + 'publication/' + this.props.location.pathname;
    return (
      <Fragment>
        <section className="news-bulletin">

          {content_loading === true && <div className="loader">

            <div className="sp sp-wave"></div>

          </div>}
          {(content_loading == false && Object.keys(content).length) ? <Fragment>
            {content.subnav.length ? <Fragment>

              <div className="publication-site-menu">

                <div className="dropdown">

                  <a className="dropdown-toggle" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">

                    <h3>Index</h3>

                  </a>

                  <div className="dropdown-menu" aria-labelledby="dropdownMenuButton">

                    <i className="fa fa-window-close"></i>

                    <ul>

                      {content.subnav.map((row, key) => {

                        return (
                          <Fragment key={key}>
                            <li className={content.id === row.id ? 'active' : ''}>
                              <Link to={`/news/${this.state.catid}/${row.id}/${row.slug}`} onClick={() => this.handleLoadContent(this.state.catid, row.id)}>{row.title}</Link>
                            </li>
                          </Fragment>
                        )
                      })}


                    </ul>

                  </div>

                </div>

              </div>
            </Fragment> : ''}

          </Fragment> : ''}

          <div className="container">
            {(content_loading == false && Object.keys(content).length) ? <Fragment>


              <div className="news-bulletin-details">

                <div className="news-bulletin-title">

                  {content.title && <h1>{content.title}</h1>}

                  {content.published_time && <p><Timestamp date={content.published_time} format="full" /></p>}

                </div>


                {/* {content.image&&  <img src={content.image.details_image} width="100%" className="mb-3" />} */}

                <Htmlcontent data={content.description} />

                <div className="share-buttons-container">

                  <div className="share-list">
                    <FacebookShareButton url={shareulr}>
                      <FacebookIcon size={32} round={true} />
                    </FacebookShareButton>
                    <LinkedinShareButton url={shareulr}>
                      <LinkedinIcon size={32} round={true} />
                    </LinkedinShareButton>
                    <TwitterShareButton url={shareulr}>
                      <TwitterIcon size={32} round={true} />
                    </TwitterShareButton>

                  </div>

                </div>
              </div>

              <div className="news-next-prev">


                {content.prev && <Link to={`/news/${this.state.catid}/${content.prev.id}/${content.prev.slug}`} className="btn btn-outline-secondary btn-prev" onClick={() => this.handleLoadContent(this.state.catid, content.prev.id)}>Back</Link>}

                {content.next && <Link to={`/news/${this.state.catid}/${content.next.id}/${content.next.slug}`} className="btn btn-outline-secondary btn-next" onClick={() => this.handleLoadContent(this.state.catid, content.next.id)}>Next</Link>}

                <div className="clearfix"></div>
              </div>

            </Fragment> : ''}

          </div>
         
        </section>
        {(content_loading == false && Object.keys(content).length) ? <TagNews tags={content.tags} newsid={this.props.slug} catid={this.props.catid}  prevSlug={prevSlug} currentSlug = {currentSlug} apiRequest={0}/> : ''}

      </Fragment>

    );
  }
}


const mapStateToProps = (state) => ({
  setting: state.utils.setting,
  details: state.pubcontent.details,
})

const mapDispatchToProps = (dispatch) => ({
  getNewsDetails: (catid, slug) => dispatch(getNewsDetails(catid, slug)),
})

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Newsdetails));